import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import { Grid } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { Stack } from "@mui/system";
import cardData from "../../data/Powerbilearningcard.json";
import CircularProgress from "@mui/material/CircularProgress";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AddIcon from "@mui/icons-material/Add";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import { styled } from "@mui/material/styles";
import LinearProgress, { linearProgressClasses } from "@mui/material/LinearProgress";
import Modal from "@mui/material/Modal";
import "./LearningCards.css";
import ArrowDropDownCircleIcon from "@mui/icons-material/ArrowDropDownCircle";
// import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
// import RemoveIcon from '@mui/icons-material/Remove';
import { useMsal } from "@azure/msal-react";
import axios from "axios";
const baseURL = "https://atci.lkm.accenture.com/shell-university-apis";
//const baseURL = "http://localhost:3004";
function PowerbiLearningCards() {
 const [modalContent, setModalContent] = useState({});
 const [openModal, setOpenModal] = useState(false);
 const Max_Length = 140;
//  const [courseData, setCourseData] = useState([]);

 const [expanded, setExpanded] = useState(false);
 const { instance } = useMsal();
 let program = "PowerBi";

 const activeAccount = instance.getActiveAccount();
 const [username, setuserName] = useState("");

 const handleOpen = (id) => {
  setOpenModal(true);
  const clickedCourseDetail = cardData.filter((obj) => {
   return obj.id === id;
  });
  setModalContent(clickedCourseDetail[0]);
 };

 const handleClose = () => {
  setOpenModal(false);
 };
//  useEffect(() => {
//   if (activeAccount) {
//    setuserName(activeAccount.idTokenClaims.enterpriseID);
//    console.log("username is", activeAccount.idTokenClaims);
//   } else {
//    setuserName(null);
//   }
//  }, [activeAccount]);
//  useEffect(() => {
//   console.log("inside fetch");

//   axios
//    .get(`${baseURL}/fetchdata/${program}/${username}`, {
//     headers: {
//      "Cache-Control": "no-cache",
//      Accept: "application/json",
//      Pragma: "no-cache",
//      Expires: "0",
//      'Authorization': localStorage.getItem("token"),
//             'Content-Type': 'application/json'
//     },
//    })
//    .then((res) => {
//     console.log("contant,nameis", res.data["DAX Formulae in Power BI"]);

//     cardData.forEach((val) => {
//      let completionPercentage = 0;
//      val.Content.forEach((content) => {
//       let tempSum =
//        res.data[content.name] === undefined
//         ? 0
//         : Number(
//            ((Number(res.data[content.name]) / content.courses.length) * 100).toFixed(0)
//           );
//       content.percent = tempSum;
//       completionPercentage = completionPercentage + tempSum;
//      });
//      console.log(completionPercentage, val.Content.length);
//      val.CompletionPercent = (completionPercentage / val.Content.length).toFixed(0);
//     });

//     setCourseData(cardData);
//    })
//    .catch((err) => {
//     console.log(err);
//    });
//  }, [username]);

 const theme = useTheme();
 const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
 const AccordionSummary = styled((props) => <MuiAccordionSummary {...props} />)(
  ({ theme }) => ({
   backgroundColor: "#E4E4E4",
   height: "45px !important",
  })
 );
 const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 5,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
   backgroundColor: theme.palette.grey[theme.palette.mode === "light" ? 200 : 800],
  },
  [`& .${linearProgressClasses.bar}`]: {
   borderRadius: 5,
   backgroundColor: theme.palette.mode === "light" ? "#A409FF" : "#308fe8",
  },
 }));

//  if (courseData == "") {
//   return null;
//  }
console.log(cardData)
 return (
  <Box
   sx={{
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: "20px",
   }}
  >
   <Box className="cardsWrapper">
    <Box className="mb-20">
     <h2>Three Phases of Power BI</h2>
     <p className="learningText">
      By providing the essential trainings, we aid in your endeavor to develop a
      prosperous Power Bi Learning journey. Regardless of your level of experience, our
      trainings will provide you the knowledge, abilities, and confidence you need to be
      successful in your Power BI developer role.
     </p>
    </Box>
    <Grid container direction={isSmallScreen ? "column" : "row"} spacing={2}>
     {cardData.map((item, i) => (
      <Grid item xs={3}>
       <Card sx={{ position: "relative" }}>
        {item.title === "Aware" ? (
         <>
          <CardMedia component="img" height="120" image={item.image} alt="card-image" />
          <Stack direction="column" spacing={3} sx={{ top: "0px" }}>
           <div className="infoText-Wrap">
            <Box sx={{ color: "white", marginTop: "8px" }}>
             <h5 className="color1" style={{ fontWeight: "600" }}>
              <span>{item.title}</span>
             </h5>
            </Box>
            <Box className="info-Duration">
             <Typography sx={{ fontSize: "12px", marginTop: "10px" }}>
              {item.description.length > Max_Length ? (
               <div>
                {`${item.description.substring(0, Max_Length)}...`}
                <span className="knowmore" onClick={() => handleOpen(item["id"])}>
                 Know More
                </span>
               </div>
              ) : (
               <div>
                {item.description}
                <span className="knowmore" onClick={() => handleOpen(item["id"])}>
                 Know More
                </span>
               </div>
              )}
             </Typography>
             <Modal
              hideBackdrop
              open={openModal}
              onClose={handleClose}
              aria-labelledby="child-modal-title"
              closeAfterTransition
              aria-describedby="child-modal-description"
              className="modal-container"
             >
              <Box className="model">
               <div className="model_heading">
                <h5 className="paramodel">{modalContent.title}</h5>
                <span className="close_btn_model" onClick={handleClose} tabIndex={0}>
                 Close
                </span>
               </div>
               <hr />
               <div className="mainRootWrapper">
                <div>
                 <h6>Description :</h6>
                 <p>{modalContent["description"]}</p>
                </div>
                <div>
                 <h6>
                  Target Audience : <span>{modalContent["target-audience"]}</span>
                 </h6>
                </div>
                {/* <div>
                 <h6>Pre-requisite :</h6>
                 <p
                  dangerouslySetInnerHTML={{ __html: modalContent["pre-requisite"] }}
                 ></p>
                </div> */}
               </div>
              </Box>
             </Modal>
             <Box
              sx={{
               position: "relative",
               display: "inline-flex",
              }}
              className="circleContainer"
             >
              <CircularProgress
               sx={{
                height: "65px !important",
                width: "65px !important",
                zIndex: "1",
                color: "#6C4AB6",
               }}
               variant="determinate"
               value={item.CompletionPercent}
              />
              <Box
               sx={{
                top: 0,
                left: 0,
                bottom: 0,
                right: 0,
                position: "absolute",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "white",
                borderRadius: "50%",
                height: "65px",
                width: "65px",
                padding: "2px",
                border: "1px solid #6C4AB6",
               }}
               className="progressAndDuration"
              >
               <Typography
                className="innerBorder1"
                sx={{
                 fontSize: "0.55rem",
                 color: "#6D398F",
                 textAlign: "center",
                 fontWeight: "600",
                }}
                variant="caption"
                component="div"
                color="text.secondary"
               >
                <span className="completionNum">{`${Math.round(
                 item.CompletionPercent
                )}%`}</span>{" "}
                complete
               </Typography>
              </Box>
             </Box>
             <Box className="durationWrapNew">
              {item.id === "4" ? (
               ""
              ) : (
               // <img className="weekImage" src={item.duration}></img>
               // <stack sx={{ position: "absolute" }}><img className="hourGlass" src="images/Selenium/LearningCards/duration-box.png">
               <stack>
                <img className="hourGlass" src="images/Hourglass.png" alt="sand clock icon"></img>{" "}
                <Typography className="hourText">
                 <span className="smallText">Duration</span>{" "}
                 <span className="bottom-color1">{Math.round(item.hour)} Hours</span>
                </Typography>
               </stack>
              )}
             </Box>
            </Box>
           </div>
          </Stack>
         </>
        ) : item.title === "Equipped" ? (
         <>
          <CardMedia component="img" height="120" image={item.image} alt="card-image" />
          <Stack direction="column" spacing={3} sx={{ top: "0px" }}>
           <div className="infoText-Wrap">
            <Box sx={{ color: "white", marginTop: "8px" }}>
             <h5 className="color2" style={{ fontWeight: "600" }}>
              <span>{item.title}</span>
             </h5>
            </Box>
            <Box className="info-Duration">
             <Typography sx={{ fontSize: "12px", marginTop: "10px" }}>
              {item.description.length > Max_Length ? (
               <div>
                {`${item.description.substring(0, Max_Length)}...`}
                <span className="knowmore" onClick={() => handleOpen(item["id"])}>
                 Know More
                </span>
               </div>
              ) : (
               <div>
                {item.description}
                <span className="knowmore" onClick={() => handleOpen(item["id"])}>
                 Know More
                </span>
               </div>
              )}
             </Typography>
             <Modal
              hideBackdrop
              open={openModal}
              onClose={handleClose}
              aria-labelledby="child-modal-title"
              closeAfterTransition
              aria-describedby="child-modal-description"
              className="modal-container"
             >
              <Box className="model">
               <div className="model_heading">
                <h5 className="paramodel">{modalContent.title}</h5>
                <span className="close_btn_model" onClick={handleClose} tabIndex={0}>
                 Close
                </span>
               </div>
               <hr />
               <div className="mainRootWrapper">
                <div>
                 <h6>Description :</h6>
                 <p>{modalContent["description"]}</p>
                </div>
                <div>
                 <h6>
                  Target Audience : <span>{modalContent["target-audience"]}</span>
                 </h6>
                </div>
                {/* <div>
                 <h6>Pre-requisite :</h6>
                 <p
                  dangerouslySetInnerHTML={{ __html: modalContent["pre-requisite"] }}
                 ></p>
                </div> */}
               </div>
              </Box>
             </Modal>
             <Box
              sx={{
               position: "relative",
               display: "inline-flex",
              }}
              className="circleContainer"
             >
              <CircularProgress
               sx={{
                height: "65px !important",
                width: "65px !important",
                zIndex: "1",
                color: "#754BFF",
               }}
               variant="determinate"
               value={item.CompletionPercent}
              />
              <Box
               sx={{
                top: 0,
                left: 0,
                bottom: 0,
                right: 0,
                position: "absolute",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "white",
                borderRadius: "50%",
                height: "65px",
                width: "65px",
                padding: "2px",
                border: "1px solid #754BFF",
               }}
               className="progressAndDuration"
              >
               <Typography
                className="innerBorder2"
                sx={{
                 fontSize: "0.55rem",
                 color: "#6D398F",
                 textAlign: "center",
                 fontWeight: "600",
                }}
                variant="caption"
                component="div"
                color="text.secondary"
               >
                <span className="completionNum">{`${Math.round(
                 item.CompletionPercent
                )}%`}</span>{" "}
                complete
               </Typography>
              </Box>
             </Box>
             <Box className="durationWrapNew">
              {item.id === "4" ? (
               ""
              ) : (
               // <img className="weekImage" src={item.duration}></img>
               <stack>
                <img className="hourGlass" src="images/Hourglass.png" alt="sand clock icon"></img>{" "}
                <Typography className="hourText">
                 <span className="smallText">Duration</span>{" "}
                 <span className="bottom-color2">{Math.round(item.hour)} Hours</span>
                </Typography>
               </stack>
              )}
             </Box>
            </Box>
           </div>
          </Stack>
         </>
        ) : item.title === "Competent" ? (
         <>
          <CardMedia component="img" height="120" image={item.image} alt="card-image" />
          <Stack direction="column" spacing={3} sx={{ top: "0px" }}>
           <div className="infoText-Wrap">
            <Box sx={{ color: "white", marginTop: "8px" }}>
             <h5 className="color3" style={{ fontWeight: "600" }}>
              <span>{item.title}</span>
             </h5>
            </Box>
            <Box className="info-Duration">
             <Typography sx={{ fontSize: "12px", marginTop: "10px" }}>
              {item.description.length > Max_Length ? (
               <div>
                {`${item.description.substring(0, Max_Length)}...`}
                <span className="knowmore" onClick={() => handleOpen(item["id"])}>
                 Know More
                </span>
               </div>
              ) : (
               <div>
                {item.description}
                <span className="knowmore" onClick={() => handleOpen(item["id"])}>
                 Know More
                </span>
               </div>
              )}
             </Typography>
             <Modal
              hideBackdrop
              open={openModal}
              onClose={handleClose}
              aria-labelledby="child-modal-title"
              closeAfterTransition
              aria-describedby="child-modal-description"
              className="modal-container"
             >
              <Box className="model">
               <div className="model_heading">
                <h5 className="paramodel">{modalContent.title}</h5>
                <span className="close_btn_model" onClick={handleClose} tabIndex={0}>
                 Close
                </span>
               </div>
               <hr />
               <div className="mainRootWrapper">
                <div>
                 <h6>Description :</h6>
                 <p>{modalContent["description"]}</p>
                </div>
                <div>
                 <h6>
                  Target Audience : <span>{modalContent["target-audience"]}</span>
                 </h6>
                </div>
                {/* <div>
                 <h6>Pre-requisite :</h6>
                 <p
                  dangerouslySetInnerHTML={{ __html: modalContent["pre-requisite"] }}
                 ></p>
                </div> */}
               </div>
              </Box>
             </Modal>
             <Box
              sx={{
               position: "relative",
               display: "inline-flex",
              }}
              className="circleContainer"
             >
              <CircularProgress
               sx={{
                height: "65px !important",
                width: "65px !important",
                zIndex: "1",
                color: "#3653FF",
               }}
               variant="determinate"
               value={item.CompletionPercent}
              />
              <Box
               sx={{
                top: 0,
                left: 0,
                bottom: 0,
                right: 0,
                position: "absolute",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "white",
                borderRadius: "50%",
                height: "65px",
                width: "65px",
                padding: "2px",
                border: "1px solid #3653FF",
               }}
               className="progressAndDuration"
              >
               <Typography
                className="innerBorder3"
                sx={{
                 fontSize: "0.55rem",
                 color: "#6D398F",
                 textAlign: "center",
                 fontWeight: "600",
                }}
                variant="caption"
                component="div"
                color="text.secondary"
               >
                <span className="completionNum">{`${Math.round(
                 item.CompletionPercent
                )}%`}</span>{" "}
                complete
               </Typography>
              </Box>
             </Box>
             <Box className="durationWrapNew">
              {item.id === "4" ? (
               ""
              ) : (
               // <img className="weekImage" src={item.duration}></img>
               <stack>
                <img className="hourGlass" src="images/Hourglass.png" alt="sand clock icon"></img>{" "}
                <Typography className="hourText">
                 <span className="smallText">Duration</span>{" "}
                 <span className="bottom-color3">{Math.round(item.hour)} Hours</span>
                </Typography>
               </stack>
              )}
             </Box>
            </Box>
           </div>
          </Stack>
         </>
        ) : (
         <>
          <CardMedia component="img" height="120" image={item.image} alt="card-image" />
          <Stack direction="column" spacing={3} sx={{ top: "0px" }}>
           <div className="infoText-Wrap">
            <Box sx={{ color: "white", marginTop: "8px" }}>
             <h5 className="color4" style={{ fontWeight: "600" }}>
              <span>{item.title}</span>
             </h5>
            </Box>
            <Box className="info-Duration">
             <Typography sx={{ fontSize: "12px", marginTop: "10px" }}>
              {item.description.length > Max_Length ? (
               <div>
                {`${item.description.substring(0, Max_Length)}...`}
                <span className="knowmore" onClick={() => handleOpen(item["id"])}>
                 Know More
                </span>
               </div>
              ) : (
               <div>
                {item.description}
                <span className="knowmore" onClick={() => handleOpen(item["id"])}>
                 Know More
                </span>
               </div>
              )}
             </Typography>
             <Modal
              hideBackdrop
              open={openModal}
              onClose={handleClose}
              aria-labelledby="child-modal-title"
              closeAfterTransition
              aria-describedby="child-modal-description"
              className="modal-container"
             >
              <Box className="model">
               <div className="model_heading">
                <h5 className="paramodel">{modalContent.title}</h5>
                <span className="close_btn_model" onClick={handleClose} tabIndex={0}>
                 Close
                </span>
               </div>
               <hr />
               <div className="mainRootWrapper">
                <div>
                 <h6>Description :</h6>
                 <p>{modalContent["description"]}</p>
                </div>
                <div>
                 <h6>
                  Target Audience : <span>{modalContent["target-audience"]}</span>
                 </h6>
                </div>
                {/* <div>
                 <h6>Pre-requisite :</h6>
                 <p
                  dangerouslySetInnerHTML={{ __html: modalContent["pre-requisite"] }}
                 ></p>
                </div> */}
               </div>
              </Box>
             </Modal>
             <Box
              sx={{
               position: "relative",
               display: "inline-flex",
              }}
              className="circleContainer"
             >
              <CircularProgress
               sx={{
                height: "65px !important",
                width: "65px !important",
                zIndex: "1",
                color: "#4BAEFD",
               }}
               variant="determinate"
               value={20}
              />
              <Box
               sx={{
                top: 0,
                left: 0,
                bottom: 0,
                right: 0,
                position: "absolute",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "white",
                borderRadius: "50%",
                height: "65px",
                width: "65px",
                padding: "2px",
                border: "1px solid #4BAEFD",
               }}
               className="progressAndDuration"
              >
               <Typography
                className="innerBorder4"
                sx={{
                 fontSize: "0.55rem",
                 color: "#6D398F",
                 textAlign: "center",
                 fontWeight: "600",
                }}
                variant="caption"
                component="div"
                color="text.secondary"
               >
                <span className="completionNum">{`${Math.round(20)}%`}</span> complete
               </Typography>
              </Box>
             </Box>
             <Box className="durationWrapNew">
              {item.id === "4" ? (
               ""
              ) : (
               // <img className="weekImage" src={item.duration}></img>
               <stack>
                <img className="hourGlass" src="images/Hourglass.png" alt="sand clock icon"></img>{" "}
                <Typography className="hourText">
                 <span className="smallText">Duration</span>{" "}
                 <span className="bottom-color4">{Math.round(item.hour)}Hours</span>
                </Typography>
               </stack>
              )}
             </Box>
            </Box>
           </div>
          </Stack>
         </>
        )}
        <Box
         sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
         }}
        >
         <Accordion sx={{ width: "100%", background: "#E4E4E4" }}>
          <AccordionSummary
           expandIcon={
            <ExpandMoreIcon
             sx={{
              fontSize: "1.9rem",
              border: "solid 1.3px #6D398F",
              color: "#6D398F",
             }}
            />
           }
          >
           <Typography sx={{ color: "#6D398F" }} className="training-type">
            Courses
           </Typography>
          </AccordionSummary>
          <AccordionDetails sx={{ width: "100%" }} className="mainAccDetails">
           <Box sx={{ width: "100%", background: "white", px: "15px" }}>
            {item.Content.map((content, i) => (
             <Stack
              direction="column"
              mt={1.5}
              className="acc-stack"
              sx={{ overflowY: "auto" }}
             >
              {item.Type == "Trainings" ? (
               <>
                <Accordion className="mainAccordion">
                 <AccordionSummary
                  sx={{
                   backgroundColor: "#FFF",
                   margin: "0px",
                   padding: "0px",
                  }}
                  expandIcon={
                   <ExpandMoreIcon
                    sx={{
                     fontSize: "1rem",
                     color: "#0041F0",
                    }}
                   />
                  }
                 >
                  {/* <ExpansionPanelSummary
                                                                    expandIcon={
                                                                       expanded==true
                                                                            ? <RemoveIcon/>
                                                                            : <AddIcon onClick={handleToggleOne} />
                                                                    }
                                                                >
                                                                </ExpansionPanelSummary> */}
                  <Stack
                   direction="row"
                   sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                    padding: "0px",
                    margin: "0px",
                   }}
                   className="courseContent"
                  >
                   <Typography
                    sx={{
                     fontWeight: "bold",
                     fontSize: "12px",
                     padding: "0px",
                    }}
                   >
                    {content.name == "Q&amp;A Feature" ? "Q&A Feature" : content.name}
                   </Typography>
                   <Typography
                    sx={{
                     color: "#A409FF",
                     fontSize: "12px",
                    }}
                   >
                    {content.percent}%
                   </Typography>
                  </Stack>
                 </AccordionSummary>
                 {content.courses.map((course, i) => (
                  <AccordionDetails sx={{ width: "100%" }}>
                   <Stack
                    direction="row"
                    spacing={2}
                    sx={{
                     display: "flex",
                     justifyContent: "space-between",
                     width: "100%",
                     alignItems: "center",
                    }}
                   >
                    <Stack
                     direction="row"
                     spacing={1}
                     sx={{
                      flex: "4",
                      display: "flex",
                      alignItems: "start",
                      width: "50%",
                     }}
                    >
                     <Box>
                      <img
                       src="images/SRE/LearningCards/bullet.svg"
                       className="learning-bullet-icon"
                       alt="hexagon icon"
                      ></img>
                     </Box>
                     <Button
                      sx={{
                       fontSize: "12px",
                       textTransform: "none",
                       textAlign: "start",
                       marginLeft: "0px",
                      }}
                      color="primary"
                      target="_blank"
                      href={course.link}
                     >
                      {course.name}
                     </Button>
                    </Stack>

                    {/* <BorderLinearProgress sx={{ width: "50px", flex: "1" }}  variant="determinate" value={course.percent} /> */}
                   </Stack>
                  </AccordionDetails>
                 ))}
                </Accordion>
               </>
              ) : (
               <Stack
                direction="row"
                spacing={1}
                sx={{
                 flex: "4",
                 display: "flex",
                 alignItems: "center",
                 margin: "5px 0px",
                }}
               >
                <Box>
                 <img
                  src="images/SRE/LearningCards/bullet.svg"
                  className="learningCasestudy-bullet-icon"
                  alt="hexagon icon"
                 ></img>
                </Box>
                <Typography sx={{ fontSize: "12px" }} color="primary">
                 {content}
                </Typography>
               </Stack>
              )}
             </Stack>
            ))}

            {/* <Box className="durationWrap">
                                                {item.id === "4" ? <img className="weekImage" src={item.duration}></img>
                                                : <stack sx={{position:"absolute"}}><img  className="clockImg" src="images/Selenium/LearningCards/clock.png">
                                               </img> <Typography className="hourText" style={{fontWeight:"bold"}}>{item.hour}</Typography></stack>}
                                                
                                            </Box> */}
           </Box>
          </AccordionDetails>
         </Accordion>
        </Box>
       </Card>
      </Grid>
     ))}
     <div className="CardCheckYourLearningJourneyLinkContainerPowerbiContainer">
      <button className="CardCheckYourLearningJourneyLinkContainerPowerbi">
       <a
        className="CardCheckYourLearningJourneyLinkContainerLinkPowerbi"
        target="_blank"
        href="https://apps.powerapps.com/play/e/default-e0793d39-0939-496d-b129-198edd916feb/a/96ff07a4-45f7-41e2-bf95-bef549815f04?tenantId=e0793d39-0939-496d-b129-198edd916feb&source=portal"
       >
        Check your Learning Progress
       </a>
      </button>
     </div>
    </Grid>
   </Box>
  </Box>
 );
}

export default PowerbiLearningCards;
